/**
 * Types d'installation gérés globalement.
 *
 * Les 4 valeurs sont remontées dans toutes les formules via la variable
 * `INSTALL` (string). Les placeholders 3D sont définis globalement (liste
 * unique) et utilisent des conditionnels sur `INSTALL` pour varier selon
 * l'install choisi par le client.
 *
 * Le `dec` figure ici à titre informatif uniquement : le calcul effectif du
 * DEC n'est PAS modifié par cette refacto (option `keep_current`).
 *
 * Mapping legacy → nouveaux IDs (renommage du 25/05/2026) :
 *   'encastrement' → 'mur'
 *   'facade-sol'   → 'sol-mur'
 *   'facade-haut'  → 'mur-haut'
 *   'sol'          → 'sol'
 *
 * SYNC : usipanel-backoffice/lib/installTypes.js
 */

export const INSTALL_TYPES = [
  { id: 'sol', label: 'Au sol, isolé', dec: 0 },
  { id: 'sol-mur', label: 'Sol + mur', dec: 0 },
  { id: 'mur', label: 'Mur', dec: 10 },
  { id: 'mur-haut', label: 'Mur haut', dec: 40 },
];

export const INSTALL_TYPE_IDS = INSTALL_TYPES.map((t) => t.id);

export const DEFAULT_INSTALL_TYPE = 'mur';

export const LEGACY_INSTALL_ID_MAP = {
  encastrement: 'mur',
  'facade-sol': 'sol-mur',
  'facade-haut': 'mur-haut',
  sol: 'sol',
};

export function canonicalInstallId(id) {
  if (id == null) return null;
  return LEGACY_INSTALL_ID_MAP[id] || id;
}

export const PLACEHOLDERS_GLOBAL_KEY = 'placeholders_global';
export const PLACEHOLDERS_LEGACY_KEY = 'placeholders_by_install';

export function normalizePlaceholdersFlat(raw) {
  let parsed = raw;
  if (typeof raw === 'string') {
    try {
      parsed = JSON.parse(raw);
    } catch {
      parsed = null;
    }
  }
  if (Array.isArray(parsed)) return parsed;
  if (!parsed || typeof parsed !== 'object') return [];

  const order = ['encastrement', 'mur', 'sol', 'facade-sol', 'sol-mur', 'facade-haut', 'mur-haut'];
  const seen = new Set();
  const out = [];
  for (const key of order) {
    const list = parsed[key];
    if (!Array.isArray(list)) continue;
    for (const ph of list) {
      const id = ph && ph.id;
      if (id && seen.has(id)) continue;
      if (id) seen.add(id);
      out.push(ph);
    }
  }
  return out;
}
